import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';

export default class BoardsAccountTemplatesRoute extends Route {
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		const promises: Record<string, Promise<unknown>> = {};

		document.body.id = 'page-boards-account-templates';

		promises.initialRequests = this.navigationService.initialRequestsPromise;

		promises.boardAccountTemplates = this.mmTemplatesService.requestBoardAccountTemplates();

		promises.boardLoopsAccountTemplates =
			this.mmTemplatesService.requestBoardLoopAccountTemplates();

		return hashSettled(promises);
	}
}
